"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetSelectCar = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../redux/slice/modalSlice");
var react_router_dom_1 = require("react-router-dom");
var useResetSelectCar = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    react_1.default.useEffect(function () {
        dispatch((0, modalSlice_1.resetSelectCar)());
    }, [pathname]);
};
exports.useResetSelectCar = useResetSelectCar;
